import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SidebarComponent } from 'app/theme/admin-layout/sidebar/sidebar.component';
import { CustomMessages } from '@shared';
import { CommonDTO } from 'app/model/common-dto';
import {
  AuditProgramAIRResponse,
  AuditProgramAIRDepartmentDTO,
} from 'app/model/audit-program-air-department';
import { AuditProgramAIRDTO } from 'app/model/audit-program-air-dto';
import { CommonService } from 'app/service/common.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ComboPopulation } from 'app/model/combo-population';
import { ManageAuditProgarmService } from 'app/service/manage-audit-progarm-service';

@Component({
  selector: 'app-editairitems',
  templateUrl: './editairitems.component.html',
  styleUrls: ['./editairitems.component.scss'],
})
export class EditairitemsComponent implements OnInit {
  selectedDepartment: string;
  selectedSection: string;
  parsedJson: any;
  commonDTO = new CommonDTO();
  //departmentComboList: ComboPopulation[] = [];
  departmentComboList: any[] = [];
  filteredDepartment: any[] = [];
  auditProgramAIRDTO = new AuditProgramAIRDTO();
  selectedAttachmentReq: boolean = true;

  @Input() selectedAuditProgramAIRDTO: AuditProgramAIRDTO;
  //FORM COMMONAIR COMPONENT
  @Input() enableAllTransaction: string;

  @Output() refreshAIRList = new EventEmitter<AuditProgramAIRDTO>();
  @Output() closePaneledits: EventEmitter<boolean> = new EventEmitter();
  departmentIdOption: FormControl = new FormControl();
  editAuditProgramAIRForm = new FormGroup({
    departmentId: new FormControl('', Validators.required),
    airDescription: new FormControl('', [Validators.required, Validators.maxLength(1000)]),
    attachmentReq: new FormControl(),
  });

  constructor(
    private sidebarComponent: SidebarComponent,
    private customMessage: CustomMessages,
    private commonService: CommonService,
    private manageAuditProgarmListService: ManageAuditProgarmService
  ) {}

  filterDepartment(value) {
    const valueLowerCase = value.toLowerCase();
    this.filteredDepartment = this.departmentComboList.filter(x =>
      x.name.toLowerCase().includes(valueLowerCase)
    );
  }

  ngOnInit() {
    this.editAuditProgramAIRForm.controls['departmentId'].disable();
    this.auditProgramAIRDTO.auditProgramId = this.selectedAuditProgramAIRDTO.auditProgramId;
    this.auditProgramAIRDTO.airTemplateId = '0';
    this.auditProgramAIRDTO.airDescription = '';
    this.auditProgramAIRDTO.departmentId = '0';
    this.auditProgramAIRDTO.sectionId = '0';
    this.auditProgramAIRDTO.statusId = '10';
    this.auditProgramAIRDTO.airDescription = this.selectedAuditProgramAIRDTO.airDescription;
    this.auditProgramAIRDTO.isAttachmentRequired = this.selectedAuditProgramAIRDTO.isAttachmentRequired;
    if (this.auditProgramAIRDTO.isAttachmentRequired == 1) this.selectedAttachmentReq = true;
    else this.selectedAttachmentReq = false;
    this.getDepartmentList();
    this.departmentIdOption.valueChanges.subscribe(value => {
      this.filterDepartment(value);
    });
  }

  getDepartmentList() {
    this.sidebarComponent.showHideLoader(true);
    this.commonService.getDepartmentList().subscribe(
      data => {
        this.parsedJson = JSON.parse(JSON.stringify(data));
        this.departmentComboList = this.parsedJson;
        this.filteredDepartment = this.departmentComboList;
        this.sidebarComponent.showHideLoader(false);
      },
      error => {
        this.sidebarComponent.showHideLoader(false);
        this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }

  editAIRItem(actionType: string) {
    let message;
    if (this.editAuditProgramAIRForm.status == 'INVALID') {
      if (this.editAuditProgramAIRForm.get('departmentId').invalid) {
        if (this.editAuditProgramAIRForm.get('departmentId').errors.required) {
          this.customMessage.showErrorMessage('cams.label.common.mandatoryDepartment', '');
          return false;
        }
      }

      if (this.editAuditProgramAIRForm.get('airDescription').invalid) {
        if (this.editAuditProgramAIRForm.get('airDescription').errors.required) {
          this.customMessage.showErrorMessage('cams.label.airScope.mandatoryAirItemName', '');
          return false;
        }

        if (this.editAuditProgramAIRForm.get('airDescription').hasError('maxLength')) {
          message = 'Max length can be 1000 characters';
          this.customMessage.showErrorMessage('cams.label.common.maxLength1000', '');
          return false;
        }
      }
    }

    this.auditProgramAIRDTO.airItemId = this.selectedAuditProgramAIRDTO.airItemId;
    this.auditProgramAIRDTO.actionType = 'U';
    this.auditProgramAIRDTO.departmentId = this.editAuditProgramAIRForm.get('departmentId').value;
    this.auditProgramAIRDTO.airDescription = this.editAuditProgramAIRForm.get(
      'airDescription'
    ).value;
    if (this.editAuditProgramAIRForm.get('attachmentReq').value)
      this.auditProgramAIRDTO.isAttachmentRequired = 1;
    else this.auditProgramAIRDTO.isAttachmentRequired = 0;
    this.sidebarComponent.showHideLoader(true);
    this.manageAuditProgarmListService
      .auditProgramAIRCrudOperation(this.auditProgramAIRDTO)
      .subscribe(
        data => {
          this.customMessage.showSuccessMessage('cams.label.common.operationCompletedSuccessfully');
          this.sidebarComponent.showHideLoader(false);

          this.refreshAIRList.emit(this.auditProgramAIRDTO);
          this.closed();
        },
        error => {
          this.sidebarComponent.showHideLoader(false);
          this.customMessage.showErrorMessage(error.error.msgId, error.error.message);
        }
      );
  }

  closed() {
    this.closePaneledits.emit(false);
  }
}
